import { IMPLEMENT_BY_API_VALUE, VEHICLE_TYPE_BY_API_VALUE } from './constants';
import type { AegRequestForm, AegVehicle } from '../../../../../models/newAEG';

type AegVehicleFormValues = Pick<AegRequestForm, 'licensePlate' | 'customer' | 'model' | 'vehicleType' | 'implement'>;

const normalizeApiValue = (value?: string) => value?.trim().toUpperCase() ?? '';

export const getVehicleFormValues = (vehicle: AegVehicle): AegVehicleFormValues => ({
    licensePlate: vehicle.licensePlate ?? '',
    customer: vehicle.vehicleOwner ?? '',
    model: vehicle.model ?? '',
    vehicleType: VEHICLE_TYPE_BY_API_VALUE[normalizeApiValue(vehicle.vehicleType)] ?? '',
    implement: IMPLEMENT_BY_API_VALUE[normalizeApiValue(vehicle.implementType)] ?? '',
});
